import { useState } from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`app-header ${menuOpen ? 'nav-open' : ''}`}>
      <Link to="/" className="logo-title" onClick={closeMenu}>IGNITE</Link>

      <button
        type="button"
        className="hamburger"
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span className="hamburger-line" />
        <span className="hamburger-line" />
        <span className="hamburger-line" />
      </button>

      {menuOpen && (
        <div
          className="nav-overlay"
          aria-hidden="true"
          onClick={closeMenu}
        />
      )}
      <nav className="nav-links">
        <Link to="/" onClick={closeMenu}>Home</Link>
        <Link to="/about" onClick={closeMenu}>About</Link>
        <Link to="/why-choose" onClick={closeMenu}>Why Choose</Link>
        <Link to="/events" onClick={closeMenu}>Events</Link>
        <Link to="/contact" onClick={closeMenu}>Contact Us</Link>
      </nav>
    </header>
  );
}

export default Navbar;
